/*
 * MAGNUM HOME & WINE - Suchbegriffe mit UND verknüpfen
 *
 * Shopify verbindet mehrere Suchwörter mit ODER. "Monte Zovo" liefert damit
 * alles mit "Monte" ODER "Zovo" - also auch Montalcino, Montepulciano,
 * Montes und Montresor: 54 Treffer statt der 16 echten (Messung 25.09.2026).
 *
 * Anführungszeichen erzwingen bei Shopify eine UND-Verknüpfung. Sie stehen um
 * JEDES Wort: bleibt eines ohne, ignoriert Shopify es beim Filtern (gemessen
 * 25.09.2026: "Ornellaia" Barolo liefert dieselben 39 Treffer wie "Ornellaia"
 * allein). Ein einzelnes Wort bleibt unangetastet - so greift options[prefix]
 * weiter und angetippte Begriffe ("Ornell") treffen nach wie vor.
 *
 * Läuft auf jeder Seite, damit auch die Suche im Kopfbereich sauber filtert.
 */
(() => {
  const buildStrictQuery = (value) => {
    const raw = (value || '').trim().replace(/\s+/g, ' ');

    if (!raw) return raw;
    if (raw.indexOf('"') !== -1) return raw;

    const words = raw.split(' ');
    if (words.length < 2) return raw;

    return words.map((word) => `"${word}"`).join(' ');
  };

  window.mgnStrictSearchQuery = buildStrictQuery;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute('action') || '').split('?')[0];
      if (!/\/search\/?$/.test(action)) return;

      const input = form.querySelector('input[name="q"]');
      if (!(input instanceof HTMLInputElement)) return;

      const strict = buildStrictQuery(input.value);
      if (strict === input.value.trim()) return;

      input.value = strict;

      if (!form.querySelector('input[name="options[prefix]"]')) {
        const prefix = document.createElement('input');
        prefix.type = 'hidden';
        prefix.name = 'options[prefix]';
        prefix.value = 'last';
        form.append(prefix);
      }
    },
    true
  );
})();
